module.exports = __webpack_public_path__ + "img/upload.c04502ff.svg";